import * as Yup from "yup";

export const isURLValid = (url: string): boolean => {
  return Yup.string().url().isValidSync(url);
};
